export default "__VITE_ASSET__CdQB_5Ny__"